<div class="template-configurator" *ngIf="template && configForm">
  <form [formGroup]="configForm" nz-form>
    <div *ngFor="let variable of template.variables" class="config-item">
      <nz-form-item>
        <nz-form-label [nzSpan]="24">{{ variable.label }}</nz-form-label>
        <nz-form-control [nzSpan]="24">
          
          <!-- Seletor de Tabs -->
          <nz-select
            *ngIf="variable.type === 'tab'"
            [formControlName]="variable.key"
            [nzMode]="variable.multiple ? 'multiple' : 'default'"
            [nzPlaceHolder]="'builderScreen.templateConfigurator.placeholder.selectTabs' | translateTA"
            nzShowSearch>
            <nz-option
              *ngFor="let tab of getTabOptions()"
              [nzValue]="tab.id"
              [nzLabel]="tab.name">
            </nz-option>
          </nz-select>

          <!-- Seletor de Panels -->
          <nz-select
            *ngIf="variable.type === 'panel'"
            [formControlName]="variable.key"
            [nzMode]="variable.multiple ? 'multiple' : 'default'"
            [nzPlaceHolder]="'builderScreen.templateConfigurator.placeholder.selectPanels' | translateTA"
            nzShowSearch>
            <nz-option
              *ngFor="let panel of getPanelOptions()"
              [nzValue]="panel.id"
              [nzLabel]="panel.name">
            </nz-option>
          </nz-select>

          <!-- Seletor de Componentes -->
          <nz-select
            *ngIf="variable.type === 'component'"
            [formControlName]="variable.key"
            [nzMode]="variable.multiple ? 'multiple' : 'default'"
            [nzPlaceHolder]="'builderScreen.templateConfigurator.placeholder.selectComponents' | translateTA"
            nzShowSearch>
            <nz-option
              *ngFor="let field of getComponentOptions(variable)"
              [nzValue]="field.id"
              [nzLabel]="field.label + ' (' + field.type + ')'">
            </nz-option>
          </nz-select>

          <!-- Seletor de Valores/Ações -->
          <nz-select
            *ngIf="variable.type === 'value' && variable.options"
            [formControlName]="variable.key"
            [nzPlaceHolder]="'builderScreen.templateConfigurator.placeholder.selectOption' | translateTA">
            <nz-option
              *ngFor="let option of variable.options"
              [nzValue]="option.value"
              [nzLabel]="option.label">
            </nz-option>
          </nz-select>

          <!-- Input de Texto Simples -->
          <input
            *ngIf="variable.type === 'value' && !variable.options"
            nz-input
            [formControlName]="variable.key"
            [placeholder]="'builderScreen.templateConfigurator.placeholder.selectValue' | translateTA">
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>
</div>

<nz-empty
  *ngIf="!template"
  [nzNotFoundContent]="'builderScreen.events.empty.selectTemplate' | translateTA"
  [nzNotFoundImage]="'simple'">
</nz-empty>



